<header
  id="app-navbar"
  class="app-header bs-navbar"
>
  <button class="bs-navbar-toggler bs-d-lg-none" type="button" appMobileSidebarToggler>&#9776;</button>
  <a class="bs-navbar-brand" [routerLink]="[defaultRoute]"></a>
  <ng-container *ngIf="locale$ | async as locale">
    <ul class="bs-nav bs-navbar-nav bs-ml-auto flex gap-8 mr-5">
      <navbar-user></navbar-user>
      <li class="nav-item">
        <a (click)="openSupportModal()"><i class="fa fa-life-ring mr-1.5">&nbsp;</i><span class="text-bold" >{{'Support' | translate: locale | async}}</span></a>
      </li>
      <ng-container *ngIf="!!showLanguageOptions">  
          <li class="nav-item">
            <a class="text-bold" (click)="openLanguageSelectorModal()"><i class="fa fa-language mr-1.5">&nbsp;</i>{{'Language' | translate: locale | async}}</a>
          </li>
      </ng-container>
        <navbar-logout [locale]="locale"></navbar-logout>
    </ul>
  </ng-container>
</header>
